<template>
    <div
        v-if="!appStore.isAppEnv"
        data-interface-section="promo-categories"
        :class="$style.promo"
    >
        <div :class="$style.texts">
            <Typography
                type="header"
                size="xs"
                :responsive="true"
                :accent="true"
            >
                {{ $tr('promoCategories.title') }}
            </Typography>
            <Typography
                type="label"
                size="xs"
                :responsive="false"
                :class="$style.text"
            >
                {{ $tr('promoCategories.text') }}
            </Typography>
        </div>
        <Links />
    </div>
</template>
<script lang="ts" setup>
import Typography from '@/components/Typography.vue'
import { useAppStore } from '@/store/app-store'

import Links from './Links.vue'

const appStore = useAppStore()
</script>
<style module>
.promo {
    display: flex;
    flex-direction: column;
    align-items: start;
    text-align: start;
    gap: 20px;
    padding: 24px 0 24px 0;
}

.texts {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.text {
    color: rgba(255, 255, 255, 0.56);
}
</style>
